import LoginVector from '../../images/medical_image.svg';
import DatavisionLogoFull from '../../images/datavision-logo-full.svg';
import AtLoginButton from '../../components/AtLoginButton';

const Home = () => {
	return (
		<div className='container-admin flex items-center'>
			<div className='hidden image lg:w-2/3 lg:flex justify-center items-center bg-[#F8F8F8] h-screen'>
				<img src={LoginVector} alt='People in a meeting' />
			</div>
			<div className='h-full min-h-screen flex items-center justify-center flex-col  w-full lg:w-1/3 px-6'>
				<div className='logo mb-8'>
					<img
						src={DatavisionLogoFull}
						alt='CMVC logo'
						className='max-w-[12.5rem] w-full'
					/>
				</div>

				<AtLoginButton />
			</div>
		</div>
	);
};

export default Home;
